import React from 'react';
import { Flex, Text, Button, Icon } from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';
import { useNewVersionAvailable } from 'utils/appVersion';

// Aviso fijo cuando hay una versión nueva desplegada. No recarga solo para no
// perder una ficha a medio llenar: el usuario decide cuándo actualizar.
const UpdateBanner = () => {
  const hasNewVersion = useNewVersionAvailable();
  if (!hasNewVersion) return null;

  return (
    <Flex
      role="status" position="fixed" bottom={{ base: '12px', md: '20px' }} left="50%" transform="translateX(-50%)"
      zIndex={2000} maxW="calc(100vw - 24px)" align="center" gap="12px" bg="white" border="1px solid"
      borderColor="cream.line" borderRadius="14px" boxShadow="0 8px 24px rgba(54,38,22,.18)"
      p="10px 12px 10px 16px" fontFamily="jakarta"
    >
      <Icon as={FiRefreshCw} boxSize="16px" color="coral.500" flexShrink={0} />
      <Text fontSize="13px" fontWeight="700" color="ink.900">Hay una nueva versión disponible</Text>
      <Button size="sm" bg="coral.500" color="white" borderRadius="10px" fontWeight="700" flexShrink={0}
        _hover={{ bg: 'coral.600' }} onClick={() => window.location.reload()}>
        Actualizar
      </Button>
    </Flex>
  );
};

export default UpdateBanner;
